import { render, staticRenderFns } from "./Locales.vue?vue&type=template&id=750ba56d"
import script from "./Locales.vue?vue&type=script&lang=ts"
export * from "./Locales.vue?vue&type=script&lang=ts"
import style0 from "./Locales.vue?vue&type=style&index=0&id=750ba56d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports